import { ProgressMeetingReportDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressMeetingService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProgressMeeting(): Observable<ProgressMeetingReportDto[]> {
    return this.http.get<ProgressMeetingReportDto[]>(
      this.url + 'project-meeting-report'
    );
  }

  createProgressMeeting(
    data: ProgressMeetingReportDto[]
  ): Observable<ProgressMeetingReportDto[]> {
    return this.http.post<ProgressMeetingReportDto[]>(
      this.url + 'project-meeting-report',
      data
    );
  }
  getSingleProgressMeeting(id: string): Observable<any> {
    return this.http.get(this.url + 'project-meeting-report/' + id);
  }

  updateProgressMeeting(
    data: ProgressMeetingReportDto[]
  ): Observable<ProgressMeetingReportDto[]> {
    return this.http.post<ProgressMeetingReportDto[]>(
      this.url + 'project-meeting-report/update',
      data
    );
  }

  deleteProgressMeeting(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-meeting-report', ids.join(', '));
    return this.http.delete(this.url + 'project-meeting-report', httpOptions);
  }
}
